import { render, staticRenderFns } from "./Betas.vue?vue&type=template&id=b78bc98e&scoped=true"
import script from "./Betas.vue?vue&type=script&lang=js"
export * from "./Betas.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=b78bc98e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78bc98e",
  null
  
)

export default component.exports